import { environment } from 'src/environments/environment';

export const AppConfig = {
  name: `Bonos Consuma`,
  keywords: `Bonos, Consuma, Bonos Consuma, Concello, Ames`,
  description: `Bonos Consuma, Concello de Ames`,
  urlToClientApp: `https://micomercio.bonosconsuma.gal`,
  version: environment.version,
};

export const FooterConfig = {
  legal: `Aviso legal`,
  support: `Soporte`,
};
